import { Row } from "react-bootstrap";
import useTranslator from "../../hooks/useTranslator";
import { Col } from "react-bootstrap/esm";

const AssignPropertyStart = (props) => {
  const { handleNextStep } = props;
  const { _t } = useTranslator();

  return (
    <>
      <div className="get-setup">
        <div className="getsetup-body mobile-getsetup-body">
          <h1>{_t("whatDoINeedToGetSetUp")}</h1>
          <Row className="five-steps custompb">
            <Col lg={4}>
              <div className="step-one">
                <p className="step-num">1</p>
                <img src="/images/stepone-img.svg"></img>
                <p className="add-detail">{_t("addRentalDetails")}</p>
              </div>
            </Col>

            <Col className="middle-step" lg={4}>
              <div className="step-one">
                <p className="step-num">2</p>
                <img src="/images/steptwo-img.svg"></img>
                <p className="add-detail">{_t("sendToTenant")}</p>
              </div>
            </Col>

            <Col lg={4}>
              <div className="step-three">
                <img src="/images/Circle.svg"></img>
                <p className="add-detail">{_t("tenantSetUpPayment")}</p>
              </div>
            </Col>
          </Row>
          <button className=" btn btngreen upbtn" onClick={handleNextStep}>
            {_t("getStarted")}
          </button>
        </div>
        <div className="getsetup-footer">
          <img src="/images/getset-bg.svg"></img>
        </div>
      </div>
    </>
  );
};

export default AssignPropertyStart;
